import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckIcon from "@mui/icons-material/Check";

const pricingData = [
  {
    title: "Gói Free",
    pricing: "0",
    goal: "Bắt đầu miễn phí với các tính năng cơ bản để khám phá và trải nghiệm hệ thống.",
    features: [
      "Tối đa 1 tổ chức",
      "Tối đa 5 thành viên trên mỗi tổ chức",
      "Tối đa 2 phòng ban và 2 nhóm",
      "Tối đa 10 task và 5 đề xuất mỗi tháng",
    ],
    buttonText: "Gói hiện tại của bạn",
    highlighted: false,
  },
  {
    title: "Gói Pro",
    pricing: "20",
    goal: "Tối ưu hiệu suất làm việc, mở rộng số lượng và quy mô tổ chức.",
    features: [
      "Tối đa 10 tổ chức",
      "Tối đa 100 thành viên trên mỗi tổ chức",
      "Không giới hạn phòng ban và nhóm",
      "Không giới hạn task và đề xuất",
      "Tùy chỉnh logo tổ chức",
      "Phân tích dữ liệu (báo cáo, thống kê)",
      "Hỗ trợ ưu tiên (email hoặc chat 24/7)",
      "Tích hợp API bên thứ ba",
      "Lịch sử chỉnh sửa",
      "Xuất báo cáo (PDF, Excel)",
    ],
    buttonText: "Nâng cấp lên Pro",
    highlighted: true,
  },
];

export const Pricing = () => {
  return (
    <Box
      sx={{
        px: 2,
        py: 4,
        maxWidth: "1300px",
        mx: "auto",
        overflowX: "hidden",
      }}
    >
      <Typography variant="h4" align="center" sx={{ mt: -4 }}>
        Nâng cấp gói của bạn
      </Typography>

      <Grid container spacing={4} justifyContent="center" mt={2}>
        {pricingData.map((plan, index) => (
          <Grid item xs={12} sm={10} md={6} lg={5} key={index}>
            <Card
              sx={{
                border: plan.highlighted
                  ? "2px solid #1976d2"
                  : "1px solid rgb(175, 175, 175)",
                boxShadow: plan.highlighted ? 3 : 1,
                borderRadius: 3,
                height: "100%",
              }}
            >
              <CardContent>
                <Typography variant="h5" color="primary" fontWeight={600}>
                  {plan.title}
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <AttachMoneyIcon
                    sx={{ color: "#1976d2", mt: "12px", fontSize: "30px" }}
                  />
                  <Typography
                    variant="h2"
                    color="primary"
                    fontWeight={600}
                    ml="-5px"
                  >
                    {plan.pricing}
                  </Typography>
                  <Typography
                    color="primary"
                    fontWeight={700}
                    sx={{
                      color: "rgba(79, 79, 79, 0.6)",
                      fontSize: "12px",
                      mt: "27px",
                      ml: "5px",
                    }}
                  >
                    USD/
                    <br />
                    tháng
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  mb={2}
                  mt={2}
                  height={50}
                >
                  {plan.goal}
                </Typography>

                <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                  {plan.highlighted ? (
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      sx={{ borderRadius: "20px", width: "100%" }}
                    >
                      {plan.buttonText}
                    </Button>
                  ) : (
                    <Button
                      //   variant="contained"
                      disableRipple
                      size="large"
                      sx={{
                        // pointerEvents: "none",
                        cursor: "not-allowed",
                        borderRadius: "20px",
                        width: "100%",
                        backgroundColor: "#AFAFAF",
                        fontWeight: 500,
                        color: "#ffffff",
                        "&:hove": {
                          cursor: "pointer",
                        },
                        "&:active": {
                          backgroundColor: "#AFAFAF",
                        },
                      }}
                    >
                      {plan.buttonText}
                    </Button>
                  )}
                </CardActions>

                <Divider sx={{ my: 2 }} />
                {/* <Typography variant="subtitle2" gutterBottom>
                    Chức năng:
                  </Typography> */}
                <List dense>
                  {plan.features.map((item, i) => (
                    <ListItem key={i} disablePadding>
                      <CheckIcon
                        sx={{ color: "#1976d2", mr: "6px", fontSize: "17px" }}
                      />
                      <ListItemText primary={`${item}`} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
